import type { FC } from 'react';
import type { PlaceholderImageProps } from './types';

export * from './types';

export const PlaceholderImage: FC<PlaceholderImageProps> = (props) => {
  const { ...rest } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" {...rest}>
      <rect fill="#d7dae0" width="100%" height="100%" />
    </svg>
  );
};
